var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('Navbar'),_c('v-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"text-h5 mb-2"},[_vm._v(_vm._s(this.$route.meta.title))]),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }